<template>
  <div class="wrap-cards">
    <div class="table-card">
      <base-table-box class="table-box">
        <base-sub-title title="房间信息" />
        <div class="btn-box">
          <a-button type="primary" @click="addRoom">新建</a-button>
          <a-button type="primary" @click="splitRoomBtn">拆分房间</a-button>
          <a-button type="primary" @click="mergeRoomBtn" v-if="dept && dept.level >=2">合并房间</a-button>
          <a-button type="primary" @click="exportImport">房源导入</a-button>
        </div>
        <base-table
          class="custom-table"
          :columns="columns"
          :dataSource="tableData"
          :pagination="page"
          :rowKey="record => record.houseId"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps}"
          @change="handleTableChange"
        >
          <template #state="record">
            <a-tag :style="{backgroundColor: handleStateColor(record)}">{{handleState(record)}}</a-tag>
          </template>
          <template #operation="record">
            <router-link class="text-btn" :to="`${$route.path}/detail/${record.treeCode}`">详情</router-link>
            <a href="javascript: void 0;" class="text-btn" @click="roomEdit(record)">修改</a>
            <a v-show="record.state !== '1'" href="javascript: void 0;" class="text-btn" @click="roomDelete(record)">删除</a>
          </template>
        </base-table>
      </base-table-box>
    </div>
    <dialog-room-edit
      :visible.sync="roomEditVisible"
      :deptId="dept ? dept.id : ''"
      :current="currentRoom"
      @submitted="editSubmitted"
    ></dialog-room-edit>
    <dialog-room-merge
      :visible.sync="roomMergeVisible"
      :current="mergeRoom"
      @submitted="mergeSubmitted"
    ></dialog-room-merge>
    <dialog-room-split
      :visible.sync="roomSplitVisible"
      :current="splitRoom"
      @submitted="splitSubmitted"
    ></dialog-room-split>
    <dialog-room-import
      :visible.sync="importVisible"
      @submitted="importSubmitted"
    ></dialog-room-import>
  </div>
</template>

<script>
import { investment } from '@/api'
import { xor, remove } from 'lodash'
import DialogRoomEdit from './DialogRoomEdit'
import DialogRoomMerge from './DialogRoomMerge'
import DialogRoomSplit from './DialogRoomSplit'
import DialogRoomImport from './DialogRoomImport'

export default {
  name: 'RoomList',
  components: {
    DialogRoomEdit,
    DialogRoomMerge,
    DialogRoomSplit,
    DialogRoomImport
  },

  props: {
    dept: Object
  },

  beforeCreate () {
    this.columns = [
      {
        title: '楼宇',
        dataIndex: 'buildingCode'
      },
      {
        title: '楼层',
        dataIndex: 'unitCode'
      },
      {
        title: '房间号',
        dataIndex: 'houseCode'
      },
      {
        title: '房间面积',
        dataIndex: 'structureArea',
        customRender: value => `${value}㎡`
      },
      {
        title: '状态',
        scopedSlots: {
          customRender: 'state'
        }
      },
      {
        title: '操作',
        scopedSlots: {
          customRender: 'operation'
        }
      }
    ]
  },

  watch: {
    dept: {
      handler (newVal) {
        if (newVal.id) this.handleReset()
      },
      deep: true
    }
  },

  data () {
    return {
      roomEditVisible: false,
      roomMergeVisible: false,
      roomSplitVisible: false,
      importVisible: false,
      loading: false,
      screenForm: this.$form.createForm(this),
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      currentRoom: {},
      selectedRowKeys: [],
      selectedRows: [],
      mergeRoom: {
        houseId: '',
        structureArea: 0,
        treeCode: ''
      },
      splitRoom: {}
    }
  },
  methods: {
    roomDelete ({ houseId, buildingCode, unitCode, houseCode }) {
      this.$confirm({
        title: '请注意',
        content: `您确认删除[${buildingCode}-${unitCode}-${houseCode}]房间吗？`,
        onOk: async () => {
          try {
            let { code, msg } = await investment.roomDelete(houseId)
            if (code === 0) {
              this.$message.success('删除成功')
              this.handleScreenSubmit()
            } else {
              this.$message.error(msg || '删除失败')
            }
          } catch (e) {
            console.error(e.message || '删除失败')
          }
        },
        okText: '删除',
        cancelText: '取消'
      })
    },
    getCheckboxProps (record) {
      return {
        props: {
          disabled: record.state !== '0',
          name: record.state
        }
      }
    },
    handleStateColor ({ selfFlag, state }) {
      if (selfFlag) {
        return '#DCDDDD'
      } else {
        if (state === '1') return '#FAEE00'
        if (state === '0') return '#8AFFC2'
      }
    },
    handleState ({ selfFlag, state }) {
      if (selfFlag) {
        return '自用'
      } else {
        if (state === '1') return '已租'
        if (state === '0') return '空置'
      }
    },
    editSubmitted () {
      if (this.currentRoom.houseId) {
        this.currentRoom = {}
        this.getTableData()
      } else {
        this.handleScreenSubmit()
      }
    },
    roomEdit (record) {
      this.currentRoom = record
      this.roomEditVisible = true
    },
    addRoom () {
      if (this.dept.level < 2) return this.$message.warn('请选择楼层')
      this.currentRoom = {}
      this.roomEditVisible = true
    },
    async getTableData () {
      let screenData = this.screenForm.getFieldsValue()
      this.loading = true
      let { code, msg, data, page } = await investment.getRoomList({
        ...screenData,
        ...this.page,
        treeCode: this.dept.id
      })
      this.loading = false
      if (code !== 0) return this.$message.error(msg || '数据获取失败')
      this.tableData = data
      this.page.total = page.total
    },
    handleScreenSubmit () {
      this.page.current = 1
      this.getTableData()
    },
    handleReset () {
      this.screenForm.resetFields()
      this.page.current = 1
      this.getTableData()
    },
    handleTableChange ({ current }) {
      this.page.current = current
      this.getTableData()
    },
    mergeSubmitted () {
      this.mergeRoom = {}
      this.selectedRowKeys = []
      this.getTableData()
    },
    splitSubmitted () {
      this.splitRoom = {}
      this.selectedRowKeys = []
      this.getTableData()
    },
    importSubmitted () {
      this.getTableData()
      this.$emit('refreshTree')
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      let changedKeys = xor(selectedRowKeys, this.selectedRowKeys)
      if (selectedRowKeys.length > this.selectedRowKeys.length) {
        this.selectedRows = this.selectedRows.concat(selectedRows.filter(x => changedKeys.indexOf(x.houseId) >= 0))
      } else {
        remove(this.selectedRows, x => changedKeys.indexOf(x.houseId) >= 0)
      }
      let structureArea = 0
      let houseId = ''
      for (let item of this.selectedRows) {
        structureArea = structureArea + item.structureArea
        houseId = item.houseId + ',' + houseId
      }
      if (selectedRowKeys.length >= 2) {
        this.mergeRoom.structureArea = structureArea
        this.mergeRoom.houseId = houseId.substring(0, houseId.length - 1)
        this.mergeRoom.treeCode = this.dept.id
        this.splitRoom = {}
      } else {
        this.splitRoom = this.selectedRows[0]
      }
      this.selectedRowKeys = selectedRowKeys
    },
    mergeRoomBtn () {
      if (this.selectedRowKeys.length < 2) {
        return this.$message.warn('至少选择两个房间!')
      }
      this.roomMergeVisible = true
    },
    splitRoomBtn () {
      if (this.selectedRowKeys.length !== 1) {
        return this.$message.warn('请选择1个房间进行拆分!')
      }
      this.roomSplitVisible = true
    },
    exportImport () {
      this.importVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-cards {
  height: 100%;
}
.table-card {
  flex: 1;
  min-height: 100%;
  padding-left: 16px;
}
.table-box {
  padding: 0 20px;
  .btn-box {
    padding: 0 0 10px;
  }
  .ant-tag {
    margin-right: 0;
  }
}
</style>
